import styled from 'styled-components';
import { FiSearch } from 'react-icons/fi';
import { User, LogIn, LogOut } from 'react-feather';
import { ToastContainer, toast } from 'react-toastify';
import { FiDownload } from 'react-icons/fi';
import DatePicker from 'react-datepicker'; // assuming you're using react-datepicker
import 'react-datepicker/dist/react-datepicker.css';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
  color: #2B3497;
`;

const TopBar = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
`;

const AreaDropdown = styled.select`
  padding: 8px 12px;
  font-size: 14px;
  border: 1.5px solid #2B3497;
  border-radius: 8px;
  background-color: #ffffff;
  color: #2B3497;
  font-family: 'Segoe UI', Semibold;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #1f2b91;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  }

  &:focus {
    outline: none;
    border-color: #1f2b91;
    box-shadow: 0px 0px 0px 3px rgba(43, 52, 151, 0.2);
  }

  option {
    background-color: #fff;
    color: #2B3497;
  }
`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1;
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000;
`;

const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 9px 10px;
  text-align: left;
  font-size: 14px;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }
  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
  font-size: 13px;
`;

const Circle = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(#ffffff, #f6f6f6);
  border-radius: 50%;
  box-shadow: 0px 10px 10px #00000024;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ProfileIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2b3497;
  font-size: 30px;
  font-weight: bold;
`;

const IconWrapper = styled.span`
  cursor: pointer;
  color: #2B3497;
  margin: 0 6px;
  display: inline-flex;
  align-items: center;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #293495;
  }
`;

const ZeroStateMessage = styled.div`
  margin-top: 20px;
  font-size: 18px;
  color: #666;
  text-align: center;
`;

// Modal styles
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  z-index: 999;
`;

const ModalContent = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  background: #fff;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 400px;
  height: 185px;
`;


const InputField = styled.input`
  background-color: transparent;
  width: 80%;
  height: 40px;
  padding: 1px;
  font-size: 14px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 2px solid #2B3497;
  border-radius: 0;
  text-align: left;
  outline: none;

  &::placeholder {
    color: #000000;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::-moz-appearance {
    textfield;
  }
`;

const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`;
const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  font-family: 'Segoe UI', 'Semibold';
  border-radius: 27px;
  opacity: 1;
  color: #fff;

  &.add-location {
    background-color: #293495;
  }

  &.reset {
    background-color: red;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  &.submit {
    background-color: #3d46b4;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  & > svg {
    margin-left: 8px;
  }
`;

const ModalButton = styled(Button)`
  padding: 8px 20px;
  font-size: 14px;
  border-radius: 12px;
  min-width: 80px;

  &.ok {
    background-color: #293495;
  }

  &.cancel {
    background-color: red;
  }
`;
const DropdownContainerTwoo = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const ExportIcono = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #293495;
`;

const OptionsPanelo = styled.div`
  position: absolute;
  top: 30px;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 150px;
  z-index: 10;
`;

const OptionItemo = styled.div`
  padding: 10px;
  cursor: pointer;
  text-align: left;
  &:hover {
    background-color: #f1f1f1;
  }
`;
const StyledDatePicker = styled(DatePicker)`
 width:175px;
  border: none;
  border-bottom: 2px solid #293495;
  padding: 5px;
  font-size: 16px;
  outline: none; /* Remove default focus outline */
    &::placeholder {
    font-size: 14px;
    color: #999; /* optional */
  }
`;
const HeaderTop = styled.div`
  display: flex;
  align-items: center;
  gap: 20px; // Adjust spacing as needed
  margin-bottom: 20px;
`;





const VisitorTackingPage = () => {
  const dummyData = Array.from({ length: 23 }, (_, index) => ({
    photo: '',
    visitID: `V${100 + index}`,
    visitType: index % 2 === 0 ? 'Business' : 'Personal',
    visitorName: `Visitor ${index + 1}`,
    mobile: `90000000${index}`,
    nationality: index % 2 === 0 ? 'USA' : 'India',
    host: index % 2 === 0 ? 'Alice' : 'Bob',
    location: index % 2 === 0 ? 'location A' : 'location B',
    area: index % 2 === 0 ? 'Area A' : 'Area B',
    checkIn: '2025-07-10 10:00 AM',
    checkOut: '2025-07-10 12:00 PM',
  }));

  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState(null);
  const [visitorData, setVisitorData] = useState([]);

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentData = filteredData.slice(startIndex, startIndex + rowsPerPage);
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [selectedVisitor, setSelectedVisitor] = useState(null);
  const [enteredMobile, setEnteredMobile] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date());


  useEffect(() => {
    const filtered = visitorData.filter((item) => {
      return Object.values(item).some((value) => {
        if (value && typeof value === 'string') {
          return value.toLowerCase().includes(searchTerm.toLowerCase());
        }
        if (value && typeof value === 'number') {
          return value.toString().includes(searchTerm);
        }
        return false;
      });
    });
    setFilteredData(filtered);
    setCurrentPage(1); // Reset to first page on new search
  }, [searchTerm, visitorData]);

  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');
  // Calculate the total number of pages
  const sortData = (data, column, direction) => {
    const sortedData = [...data].sort((a, b) => {
      if (direction === 'asc') {
        return a[column] > b[column] ? 1 : -1;
      } else {
        return a[column] < b[column] ? 1 : -1;
      }
    });
    return sortedData;
  };

  const handleSort = (column) => {
    const direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortDirection(direction);
    const sortedData = sortData(filteredData, column, direction);
    setVisitorData(sortedData);
  };


  const formatDateWithMidnight = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day} 00:00:00.0000`; // Note the space instead of 'T'
  };
  const fetchVisitorData = async (areaID, date) => {

    const formattedDate = formatDateWithMidnight(date);

    try {
      const response = await axios.get(`Dashboard/GetVisitorTrackingByArea/${areaID}`, {
        params: {
          Date: formattedDate,
        },
      });
      setVisitorData(response.data.details);
    } catch (error) {
      console.error("Failed to fetch visitor data:", error);
      setVisitorData([]);
    }
  };



  useEffect(() => {
    const fetchAreas = async () => {
      try {
        const response = await axios.get('Location/GetAllBuildings');
        const fetchedAreas = response.data || [];

        const allAreaOption = {
          id: 0,
          name: 'All Areas',
          gate: '',
        };

        const formattedAreas = [allAreaOption, ...fetchedAreas];
        setAreas(formattedAreas);
        setSelectedArea(allAreaOption);

        // Default fetch with allAreaOption and current date
        const today = new Date();
        setSelectedDate(today);
        fetchVisitorData(allAreaOption.id, today);
      } catch (error) {
        console.error('Error fetching areas:', error);
      }
    };

    fetchAreas();
  }, []);


  const handleModalConfirm = () => {
    if (enteredMobile === selectedVisitor.mobile) {
      const payload = {
        visitId: selectedVisitor.visitID,
        userId: 'LoggedInUser123', // Replace with actual user ID
        areaId: 'AreaXYZ',         // Replace with actual area ID
        visitType: selectedVisitor.visitType
      };
      console.log('✅ Validated:', payload);
      setShowModal(false);
      setEnteredMobile('');
    } else {
      toast.error(' Mobile number mismatch!');
    }
  };
  const handleChange = async (e) => {
    const selectedId = parseInt(e.target.value);
    const selected = areas.find((area) => area.id === selectedId);
    setSelectedArea(selected);

    if (selectedDate) {
      fetchVisitorData(selectedId, selectedDate);
    }
  };


  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (selectedArea) {
      fetchVisitorData(selectedArea.id, date);
    }
  };

  const [isPanelOpenE, setIsPanelOpenE] = useState(false);

  const togglePanelE = () => {
    setIsPanelOpenE((prevState) => !prevState);
  };

  const handleExportOptionClick = (format) => {
    if (format === 'excel') {
      exportToExcel(); // Call the Excel export function
    } else if (format === 'pdf') {
      exportToPDF(); // Call the PDF export function
    }

    // Close the panel after making a selection
    setIsPanelOpenE(false);
  };
  const exportToExcel = () => {
    const exportData = filteredData.map((row) => ({
      'Visit ID (Appt ID)': row.appointmentId || '',
      'Visit Type': row.source || '',
      'Visitor Name': row.visitorName || '',
      'Visitor Type': row.visitorTypeDesc || '',
      'Visitor Mobile': row.visitorMobile || '',
      'Nationality': row.nationality || '',
      'Host': row.host || '',
      'Location': row.location || '',
      'Area/Gate': row.area || '',
      'Check-In ': row.areaCheckInDateTime || '',
      'Check-Out ':
        (row.areaCheckOutDateTime === "0001-01-01T00:00:00" || row.areaCheckOutDateTime === null)
          ? ''
          : row.areaCheckOutDateTime || '',
      'Last Area Check-In': row.area || '',

    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Visitor Tracking Report');

    worksheet['!cols'] = [
      { wpx: 120 }, // Visit ID
      { wpx: 100 }, // Visit Type
      { wpx: 150 }, // Visitor Name
      { wpx: 130 }, // Mobile
      { wpx: 100 }, // Nationality
      { wpx: 150 }, // Host
      { wpx: 150 }, // Location
      { wpx: 120 }, // Area
      { wpx: 160 }, // Check-In
      { wpx: 160 }, // Check-Out
      { wpx: 160 }, // Check-Out

    ];

    XLSX.writeFile(workbook, 'Visitor_Tracking_Report.xlsx');
  };


  const exportToPDF = () => {
    const doc = new jsPDF('landscape');
    doc.text('Visitor Tracking Reports', 14, 16);
    doc.autoTable({
      head: [
        ['Photo', 'Visit ID (Appt ID)', 'Visit Type	', 'Visitor Name', 'Visitor Type', 'Visitor Mobile', 'Nationality', 'Host', 'Location', 'Area/Gate', 'Check-In', 'Check-Out', 'Last Area Check-In']
      ],
      body: filteredData.map((row) => [
        '',
        row.appointmentId,
        row.source,
        row.visitorName,
        row.visitorTypeDesc,
        row.visitorMobile,
        row.nationality,
        row.host,
        row.location,
        row.area,
        row.areaCheckInDateTime,
        (row.areaCheckOutDateTime === "0001-01-01T00:00:00" || row.areaCheckOutDateTime === null)
          ? ''
          : row.areaCheckOutDateTime || '', row.area,

      ]),
      startY: 30,
      theme: 'grid',
      didDrawCell: (data) => {
        // Ensure we only process body cells, not header or footers
        if (data.section === 'body' && data.column.index === 0 && filteredData[data.row.index]?.photo) {
          const img = `data:image/png;base64,${filteredData[data.row.index].photo}`;

          // Get cell dimensions
          const cellWidth = data.cell.width;
          const cellHeight = data.cell.height;

          // Define the image size (smaller to fit properly)
          const imgSize = Math.min(cellWidth, cellHeight) - 2; // Padding of 2px on each side

          // Center the image within the cell
          const xOffset = data.cell.x + (cellWidth - imgSize) / 2;
          const yOffset = data.cell.y + (cellHeight - imgSize) / 2;

          doc.addImage(img, 'PNG', xOffset, yOffset, imgSize, imgSize);
        }
      },
    });
    doc.save('Visitor_Tracking_Report.pdf');
  };




  return (
    <Container>
      <Header>
        <HeaderTop>
          <Heading>Visitor Tracking</Heading>
          <StyledDatePicker
            selected={selectedDate}
            onChange={handleDateChange}
            dateFormat="yyyy-MM-dd"
            maxDate={new Date()}
            placeholderText="Select a date"
          />
        </HeaderTop>
        {/* <Heading>Visitor-Tracking</Heading> */}


        <TopBar>
          <AreaDropdown value={selectedArea?.id || 0} onChange={handleChange}>
            {areas.map((area) => (
              <option key={area.id} value={area.id}>
                {area.id === 0 ? area.name : `${area.location} - ${area.name}`}
              </option>
            ))}
          </AreaDropdown>

          <SearchBox>
            <SearchIcon />
            <SearchInput
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </SearchBox>
          <DropdownContainerTwoo>
            <ExportIcono onClick={togglePanelE} title="Export">
              <FiDownload size={25} />
            </ExportIcono>
            {isPanelOpenE && (
              <OptionsPanelo>
                <OptionItemo onClick={() => handleExportOptionClick('excel')}>Excel</OptionItemo>
                <OptionItemo onClick={() => handleExportOptionClick('pdf')}>PDF</OptionItemo>
              </OptionsPanelo>
            )}
          </DropdownContainerTwoo>

        </TopBar>
      </Header>

      <TableContainer>
        {currentData.length === 0 ? (
          <ZeroStateMessage>No visitors to display</ZeroStateMessage>
        ) : (
          <StyledTable>
            <thead>
              <tr>

                <TableHeader>Photo</TableHeader>
                <TableHeader onClick={() => handleSort('appointmentId')}>Visit ID (Appt ID){sortColumn === 'appointmentId' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                <TableHeader onClick={() => handleSort('source')}>Visit Type{sortColumn === 'source' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                <TableHeader onClick={() => handleSort('visitorName')}>Visitor Name{sortColumn === 'visitorName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                <TableHeader onClick={() => handleSort('visitorTypeDesc')}>Visitor Type{sortColumn === 'visitorTypeDesc' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                <TableHeader onClick={() => handleSort('visitorMobile')}>Mobile{sortColumn === 'visitorMobile' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                <TableHeader onClick={() => handleSort('nationality')}>Nationality{sortColumn === 'nationality' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                <TableHeader onClick={() => handleSort('host')}>Host{sortColumn === 'host' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                <TableHeader onClick={() => handleSort('location')}>Location{sortColumn === 'location' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                <TableHeader onClick={() => handleSort('area')}>Area/ Gate{sortColumn === 'area' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                <TableHeader onClick={() => handleSort('areaCheckInDateTime')}>Check-In{sortColumn === 'areaCheckInDateTime' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                <TableHeader onClick={() => handleSort('areaCheckOutDateTime')}>Check-Out{sortColumn === 'areaCheckOutDateTime' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                <TableHeader onClick={() => handleSort('area')}>Last Area Check-In{sortColumn === 'area' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
              </tr>
            </thead>
            <tbody>
              {currentData.map((visitor, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Circle>
                      {visitor.photo ? (
                        <img
                          src={`data:image/png;base64,${visitor.photo}`}
                          alt="Profile"
                          style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                        />
                      ) : (
                        <ProfileIcon><User size={15} /></ProfileIcon>
                      )}
                    </Circle>
                  </TableCell>
                  <TableCell>{visitor.appointmentId}</TableCell>
                  <TableCell>{visitor.source}</TableCell>
                  <TableCell>{visitor.visitorName}</TableCell>
                  <TableCell>{visitor.visitorTypeDesc}</TableCell>
                  <TableCell>{visitor.visitorMobile}</TableCell>
                  <TableCell>{visitor.nationality}</TableCell>
                  <TableCell>{visitor.host}</TableCell>
                  <TableCell>{visitor.location}</TableCell>
                  <TableCell>{visitor.area}</TableCell>
                  <TableCell>
                    {visitor.areaCheckInDateTime === "0001-01-01T00:00:00" || visitor.areaCheckInDateTime === null
                      ? " "
                      : new Intl.DateTimeFormat('en-CA', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: false
                      }).format(new Date(visitor.areaCheckInDateTime))
                        .replace(',', ' :')}
                  </TableCell>
                  <TableCell>
                    {visitor.areaCheckOutDateTime === "0001-01-01T00:00:00" || visitor.areaCheckOutDateTime === null
                      ? " "
                      : new Intl.DateTimeFormat('en-CA', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: false
                      }).format(new Date(visitor.areaCheckOutDateTime))
                        .replace(',', ' :')}
                  </TableCell>
                  <TableCell>{visitor.area}</TableCell>

                  {/* <TableCell>{visitor.visitID}</TableCell>
                                    <TableCell>{visitor.visitType}</TableCell>
                                    <TableCell>{visitor.visitorName}</TableCell>
                                    <TableCell>{visitor.mobile}</TableCell>
                                    <TableCell>{visitor.nationality}</TableCell>
                                    <TableCell>{visitor.host}</TableCell>
                                    <TableCell>{visitor.location}</TableCell>
                                    <TableCell>{visitor.area}</TableCell>
                                    <TableCell>{visitor.checkIn}</TableCell>
                                    <TableCell>{visitor.checkOut}</TableCell>
                                    <TableCell>{visitor.checkOut}</TableCell> */}
                </TableRow>
              ))}
            </tbody>
          </StyledTable>
        )}
      </TableContainer>

      <PaginationContainer>
        <PaginationButton onClick={() => setCurrentPage(p => p - 1)} disabled={currentPage === 1}>
          Previous
        </PaginationButton>
        <DropdownSelect value={currentPage} onChange={(e) => setCurrentPage(Number(e.target.value))}>
          {Array.from({ length: totalPages }, (_, i) => (
            <option key={i + 1} value={i + 1}>Page {i + 1}</option>
          ))}
        </DropdownSelect>
        <PaginationButton onClick={() => setCurrentPage(p => p + 1)} disabled={currentPage === totalPages}>
          Next
        </PaginationButton>
      </PaginationContainer>

      {showModal && (
        <>
          <ModalOverlay />
          <ModalContent>
            <h3>Confirm {modalType === 'checkin' ? 'Check-In' : 'Check-Out'}</h3>
            <InputField
              type="number"
              placeholder="Enter Mobile Number"
              value={enteredMobile}
              onChange={(e) => setEnteredMobile(e.target.value)}
            />
            <ModalActions>
              <ModalButton className="cancel" onClick={() => setShowModal(false)}>Cancel</ModalButton>
              <ModalButton className="ok" onClick={handleModalConfirm}>OK</ModalButton>
            </ModalActions>
          </ModalContent>
        </>
      )}
      <ToastContainer />

    </Container>
  );
};

export default VisitorTackingPage;
